export enum DirectoryType {
  SiteRoot = 0,
  SiteFiles = 1,
  EmailQueueAttachments = 2,
  Upload = 3,
  Collaboration = 4,
  UserProfile = 5,
}
